import { Box, Button, Heading } from '@primer/react';
import ComponentLayout from '~/src/layouts/component-layout';
import * as React from 'react';
export default {
  Box,
  Button,
  Heading,
  ComponentLayout,
  React
};